import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import { getRawCollection } from '@adornis/baseql/server/collections.js';

@Entity()
export class Machine extends MongoEntity {
  static override _class = 'Machine';
  static override _collectionName = 'machines';

  // System fields
  @Field(() => String) machineID: Maybe<string>;
  @Field(() => String) rowChecksum: Maybe<string>;
  @Field(() => Date) modifiedOn: Maybe<Date>;

  // Machine details
  @Field(() => String) dossierNumber: Maybe<string>;
  @Field(() => String) machineName: Maybe<string>;
  @Field(() => String) serialNumber: Maybe<string>;
  @Field(() => String) productGroup: Maybe<string>;
  @Field(() => String) machineType: Maybe<string>;
  @Field(() => String) technology: Maybe<string>;

  // Accounts and contacts
  @Field(() => String) technicalAccount: Maybe<string>;
  @Field(() => String) technicalContact: Maybe<string>;
  @Field(() => String) commercialAccount: Maybe<string>;
  @Field(() => String) commercialContact: Maybe<string>;

  // Technical Account address
  @Field(() => String) salesArea: Maybe<string>;
  @Field(() => String) address1Country: Maybe<string>;
  @Field(() => String) address1Street1: Maybe<string>;
  @Field(() => String) address1ZipPostalCode: Maybe<string>;
  @Field(() => String) address1City: Maybe<string>;

  // Contract and manufacturer
  @Field(() => String) activeContract: Maybe<string>;
  @Field(() => String) manufacturer: Maybe<string>;
  @Field(() => String) reactionTimeAgreement: Maybe<string>;

  // Commercial Account details
  @Field(() => String) commercialAccountName: Maybe<string>;
  @Field(() => String) commercialAccountNumber: Maybe<string>;

  // Miscellaneous
  @Field(() => String) division: Maybe<string>;
  @Field(() => String) software: Maybe<string>;
  @Field(() => String) softwareVersion: Maybe<string>;
  @Field(() => Date) manufacturingDate: Maybe<Date>;
  @Field(() => Date) acceptanceDateAx: Maybe<Date>;
}

export const getAccountNumberFromDossierNumber = async (dossierNumber: string): Promise<string | null> => {
  const collection = await getRawCollection(Machine._collectionName);
  const machine = await collection.findOne({ dossierNumber });
  return machine?.commercialAccountNumber ?? null;
};
